<div class="slider-container">
  <!-- Slider customizado -->
  <div #sliderWrapper class="custom-slider-wrapper">
    <!-- Valores dos pontos acima -->
    <div class="step-values">
      @for (step of majorSteps; track $index) {
        <div class="step-value" [style.left]="getStepPosition(step)">
          {{ step }}
        </div>
      }
    </div>

    <!-- Barra de fundo com cores dinâmicas -->
    <div class="color-bar">
      @for (segment of processedSegments; track $index) {
        <div
          class="bar-segment"
          [style.width]="segment.width"
          [style.background]="segment.color"
        ></div>
      }
    </div>

    <!-- Pontos dos steps na barra -->
    <div class="steps-container">
      @for (step of majorSteps; track $index) {
        <div class="step" [style.left]="getStepPosition(step)"></div>
      }
    </div>

    <button
      type="button"
      class="slider-thumb"
      [class.dragging]="isDragging"
      [class.read-only]="isReadOnly"
      [style.left]="getThumbPosition()"
      role="slider"
      aria-label="Percentual de entrada"
      [attr.aria-readonly]="isReadOnly"
      aria-valuemin="0"
      aria-valuemax="90"
      [attr.aria-valuenow]="isDragging ? dragValue : value"
      (pointerdown)="onThumbPointerDown($event)"
      (pointermove)="onThumbPointerMove($event)"
      (pointerup)="onThumbPointerUp($event)"
      (pointercancel)="onThumbPointerCancel($event)"
      (keydown)="onThumbKeyDown($event)"
    ></button>
  </div>

  <!-- Legendas dinâmicas -->
  <div class="zone-labels">
    @for (segment of processedSegments; track $index) {
      @if (segment.label) {
        <span
          class="zone-label"
          [style.color]="segment.color"
          [style.left]="getLabelPosition($index)"
        >
          {{ segment.label }}
        </span>
      }
    }
  </div>
</div>
